import {} from "./Parameter.js";
export function formatParameterWithoutType(parameter) {
    if (parameter.isPrincipal) {
        return `${parameter.name}!`;
    }
    else {
        return `${parameter.name}`;
    }
}
//# sourceMappingURL=formatParameterWithoutType.js.map